// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LwPsf","fixedHeight":"styles_fixedHeight__WwX1m"};